import { useQuery } from 'react-query'
import { PaymentCondition } from '../../Interfaces/paymentCondition'
import { api } from '../api'

export type PaymentConditionsQuery = {
  page?: number
  limit?: number
  search?: string
  is_active?: boolean | string
}

type PaymentConditionsResponse = {
  paymentConditions: PaymentCondition[]
  totalCount: number
}

export async function getPaymentConditions(params?: PaymentConditionsQuery): Promise<PaymentConditionsResponse> {
  const { data } = await api.get('payment-conditions', {
    params,
  })

  const payload = data?.data

  if (payload?.data) {
    return {
      paymentConditions: payload.data,
      totalCount: payload.meta?.total ?? payload.data.length,
    }
  }

  return {
    paymentConditions: payload ?? [],
    totalCount: Array.isArray(payload) ? payload.length : 0,
  }
}

export function usePaymentConditions(params?: PaymentConditionsQuery) {
  return useQuery(['payment-conditions', params], () => getPaymentConditions(params), {
    staleTime: 5000,
  })
}
